import { render, staticRenderFns } from "./InviteConfirmation.vue?vue&type=template&id=45c327fe&scoped=true&"
import script from "./InviteConfirmation.vue?vue&type=script&lang=js&"
export * from "./InviteConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./InviteConfirmation.vue?vue&type=style&index=0&id=45c327fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c327fe",
  null
  
)

export default component.exports